import 'bootstrap/dist/js/bootstrap.min'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
import 'flatpickr/dist/flatpickr.css'
import 'ag-grid-enterprise/dist/styles/ag-grid.css'
import 'ag-grid-enterprise/dist/styles/ag-theme-balham.css'

import '@/assets/style.scss'
